/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Container, Grid, Segment, Message,
  Rail, Sticky, Header,
} from 'semantic-ui-react';
import _ from 'lodash';

import { base } from '../../../config/constants';
import { AlertBox, ConfirmBox, SelectBox } from '../../../components/Modals/index';
import { NewsList } from '../../../components/News/index';
import { MapListView } from '../../../components/Maps/index';

export default class History extends Component {
  static propTypes = {
    history: PropTypes.object,
    habilitations: PropTypes.object,
    themeId: PropTypes.string,
    themeType: PropTypes.string,
  }

  static defaultProps = {
    habilitations: { uid: null },
    history: null,
    themeId: null,
    themeType: 'themes',
  }

  constructor(props) {
    super(props);
    this.state = {
      themeNewsItem: [],
      themeNewsItemLoading: true,
    };
  }

  componentDidMount() {
    this._ismounted = true;
    if (this.props.themeId) {
      this.selectedBinding = base.bindToState(`${this.getNotificationObjectName()}/${this.props.themeId}`, {
        context: this,
        state: 'themeNewsItem',
        asArray: true,
        queries: {
          orderByKey: true,
        },
        then: () => this.setState({ themeNewsItemLoading: false }),
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.themeId !== this.props.themeId) {
      this.setState({ themeNewsItemLoading: true });
      base.removeBinding(this.selectedBinding);
      if (nextProps.themeId) {
        this.selectedBinding = base.bindToState(`${this.getNotificationObjectName()}/${this.props.themeId}`, {
          context: this,
          state: 'themeNewsItem',
          asArray: true,
          queries: {
            orderByKey: true,
          },
          then: () => this.setState({ themeNewsItemLoading: false }),
        });
      }
    }
  }

  componentWillUnmount() {
    this._ismounted = false;
  }

  getNotificationObjectName = () => {
    switch (this.props.themeType) {
      case 'themes':
        return 'notifs';
      case 'citizenly':
        return 'notifsCitizenly';
      case 'elected':
        return 'notifsElected';
      default:
        return 'notifs';
    }
  }

  selectedBinding;

  handleContextRef = contextRef => this.setState({ contextRef })

  render() {
    // console.log(this.props.habilitations);
    // console.log(this.state.selectedAdmin);
    const { contextRef } = this.state;
    const noneSelected = this.props.themeId === null;
    const nonePublished = this.props.themeId !== null && !this.state.themeNewsItemLoading
      && this.state.themeNewsItem.length < 1;
    return (
      <Container>
        <Segment basic loading={this.state.themeNewsItemLoading} disabled={noneSelected}>
          <Grid columns={2}>
            <Grid.Column>
              <div ref={this.handleContextRef}>
                <Segment textAlign="center" basic style={{ minHeight: 550 }}>
                  {!noneSelected && <NewsList
                    themeId={this.props.themeId}
                    newsItemsObjects={this.state.themeNewsItem}
                    themeType={this.props.themeType}
                    getPositionTarget={(position) => {
                      const targetPositionWithZoom = {
                        zoom: 11,
                        lat: position.latitude,
                        lng: position.longitude,
                      };
                      // console.log(targetPositionWithZoom);
                      this.setState({ targetPosition: targetPositionWithZoom });
                    }}
                  />}
                  {nonePublished && (
                    <Message
                      info
                      header="Aucune notification"
                      content="Il semblerait qu'aucune notification n'a été envoyée aux destinataires de ce flux"
                    />
                  )}
                  <Rail position="right" style={{ width: '100%' }}>
                    {
                      this.state.themeNewsItemLoading ? null : (
                        <Sticky pushing context={contextRef} offset={80}>
                          <Header as="h3">Géolocalisation des notifications</Header>
                          <Segment>
                            <MapListView
                              newsItemsObjects={
                                _.filter(
                                  this.state.themeNewsItem,
                                  i => (
                                    i.latitude
                                    && i.longitude
                                    && (i.latitude.trim() !== '0' && i.longitude.trim() !== '0')
                                  ),
                                )
                              }
                              initialPosition={this.state.targetPosition}
                            />
                          </Segment>
                        </Sticky>
                      )
                    }
                  </Rail>
                </Segment>
              </div>
            </Grid.Column>
          </Grid>
        </Segment>
        <AlertBox
          propagateClosure={() => this.setState({ alert: { open: false } })}
          {...this.state.alert}
        />
        <ConfirmBox
          propagateClosure={() => this.setState({ confirm: { open: false } })}
          {...this.state.confirm}
        />
        <SelectBox
          propagateClosure={() => this.setState({ pick: { open: false } })}
          {...this.state.pick}
        />
      </Container>
    );

    // console.log(this.props.themeId);
  }
}



// WEBPACK FOOTER //
// ./src/screens/protected/_common/History.js